export function truncate(s: string, length: number) {
  if (s.length <= length) {
    return s;
  }

  let start = length - 1;

  // A-z
  while (s.charCodeAt(start) >= 65 && s.charCodeAt(start) <= 122) {
    start++;
  }

  return `${s.split("").slice(0, start).join("")}...`;
}
